import * as React from "react";
import { createStyles, makeStyles, Paper } from "@material-ui/core";
import { Stakeholder } from "core/src/domain";
import {
    DisplayStakeholder,
    RelodeTheme,
    Text,
} from "../..";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            paper: {
                padding: theme.spacing(2),
            },
            header: {
                marginBottom: 15,
            },
            detailsFlex: {
                display: "flex",
                flexDirection: "column",
                gap: 16,
                alignItems: "start",
            },
            marginZero: {
                marginTop: 0,
            },
        }),
    { name: "OwnershipView" }
);

interface OwnershipViewProps {
    jobId?: number;
    jobName?: string;
    referrer?: Stakeholder;
    manager?: Stakeholder;
    leadId?: number;
    candidateFullName?: string;
    isLoggedInUserReferrer?: boolean;
    isLoggedInUserManager?: boolean;
}

export const OwnershipView = (props: OwnershipViewProps) => {
    const {
        jobId,
        jobName,
        referrer,
        manager,
        leadId,
        candidateFullName,
        isLoggedInUserReferrer,
        isLoggedInUserManager,
    } = props;
    const classes = useStyles({});

    return (
        <Paper elevation={1} className={classes.paper}>
            <Text variant="h2" gutterBottom>ownership</Text>
            <div className={classes.detailsFlex}>
                <DisplayStakeholder
                    label="referred by"
                    stakeholder={referrer}
                    messageProps={{
                        jobId: jobId,
                        jobName: jobName,
                        leadId: leadId,
                        leadName: candidateFullName,
                    }}
                    showHeader={false}
                    hideMessageLink={isLoggedInUserReferrer}
                    hidePhoneLink={isLoggedInUserReferrer}
                />
                {!!manager ? (
                    <DisplayStakeholder
                        label="managed by"
                        stakeholder={manager}
                        messageProps={{
                            jobId: jobId,
                            jobName: jobName,
                            leadId: leadId,
                            leadName: candidateFullName,
                        }}
                        showHeader={false}
                        hideMessageLink={isLoggedInUserManager}
                        hidePhoneLink={isLoggedInUserManager}
                    />
                ) : null }
            </div>
        </Paper>
    );
};
